import React from 'react'
import {Link, NavLink} from 'react-router-dom';
import './login.css'

class LoginArticle extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="login-article">
                <img className="login-title" src={require("../assert/CampusForm.png")} alt="CampusForm"></img>
                <div className="login-username">
                    <p className="login-username-title">账号</p>
                    <div className="login-username-border"></div>
                    <textarea className="login-username-input"></textarea>
                </div>
                <div className="login-password">
                    <p className="login-password-title">密码</p>
                    <div className="login-password-border"></div>
                    <textarea className="login-password-input"></textarea>
                </div>
                <Link to="teacherHome"><img className="login-login" src={require("./login.png")} alt="登录"></img></Link>
            </div>
        );
    }
}

export default LoginArticle;